module.exports = __webpack_public_path__ + "static/media/trust_icons_emandate.d84667f1.svg";